export const MOCKED_ARTICLE_NUMBER = 6;

export const TOPIC_DATA_SEO: Record<
  string,
  { title: string; description: string }
> = {
  bewerbung: {
    title: 'CAREER_HUB_TOPIC_PAGE_BEWERBUNG_TITLE',
    description: 'CAREER_HUB_TOPIC_PAGE_BEWERBUNG_DESCRIPTION',
  },
  gehalt: {
    title: 'CAREER_HUB_TOPIC_PAGE_GEHALT_TITLE',
    description: 'CAREER_HUB_TOPIC_PAGE_GEHALT_DESCRIPTION',
  },
  'fuhrung-und-management': {
    title: 'CAREER_HUB_TOPIC_PAGE_FUHRUNG_TITLE',
    description: 'CAREER_HUB_TOPIC_PAGE_FUHRUNG_DESCRIPTION',
  },
  arbeitsrecht: {
    title: 'CAREER_HUB_TOPIC_PAGE_ARBEITSRECHT_TITLE',
    description: 'CAREER_HUB_TOPIC_PAGE_ARBEITSRECHT_DESCRIPTION',
  },
  'frau-macht-karriere': {
    title: 'CAREER_HUB_TOPIC_PAGE_FRAU_TITLE',
    description: 'CAREER_HUB_TOPIC_PAGE_FRAU_DESCRIPTION',
  },
};
